import { z } from "zod";
import { IdSchema } from "./primitives";

/** Where players put an entry on a board: in a list, its place in the order; on a grid, its cell. */
export const PlayerPlaceSchema = z.union([
  z.number().int().nonnegative(),
  z.tuple([z.number().int().nonnegative(), z.number().int().nonnegative()]),
]);
export type PlayerPlace = z.infer<typeof PlayerPlaceSchema>;

export const BoardOperationSchema = z.discriminatedUnion("type", [
  z.strictObject({
    type: z.literal("board.arranged"),
    canvasId: IdSchema,
    places: z.record(IdSchema, PlayerPlaceSchema).meta({
      description:
        "The players' own place for entries on a list or a grid, by id, for everyone on the perspective. Entries left out keep the board's.",
    }),
  }),
]);
export type BoardOperation = z.infer<typeof BoardOperationSchema>;
